import { render } from "./nav-bar.vue?vue&type=template&id=523f3308&scoped=true&lang=html"
import script from "./nav-bar.vue?vue&type=script&lang=js"
export * from "./nav-bar.vue?vue&type=script&lang=js"

import "./nav-bar.vue?vue&type=style&index=0&id=523f3308&lang=scss&scoped=true"

import exportComponent from "/builds/unistroy/frontend.vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-523f3308"]])

export default __exports__